type ClassNameValue = string | string[] | false | null | undefined;

/**
 * Sanitizes, concatenates, and returns an object containing the `className` prop,
 * suitable for spreading directly onto a JSX element (e.g. `<div {...classNames(...)} />`).
 * @param args - Class names, falsy values are dropped (e.g. `condition && "my-class"`)
 */
export default function classNames(
  ...args: ClassNameValue[]
): { className?: string } {
  if (args.length === 0) {
    return {};
  }

  const className = args
    .filter((value): value is string | string[] => Boolean(value))
    .reduce<string[]>((flat, value) => flat.concat(value), [])
    .join(" ");

  return className ? { className } : {};
}
